import { DecisionTree } from '@/components/decision-tree';
import HeaderEditAnswer from '@/components/header-edit-answer/header-edit-answer';
import { Modal } from '@cmpsr/components';
import useModalEditAnswerController from './modal-edit-answer.controller';

type ModalEditAnswerProps = {
  isOpen: boolean;
  onCloseClick: () => void;
  surveyItemId: string | null;
};

export default function ModalEditAnswer({ isOpen, onCloseClick, surveyItemId }: ModalEditAnswerProps) {
  const { userQuestionnaire, editQuestion, uploadAnswer } = useModalEditAnswerController({
    surveyItemId,
    onCloseClick,
  });

  if (!userQuestionnaire || !editQuestion) return null;

  return (
    <Modal isOpen={isOpen} onClose={onCloseClick} size="full" trapFocus={false}>
      <Modal.Content>
        <Modal.Body bg="background-page" p={0} display="flex">
          <DecisionTree
            userQuestionnaire={userQuestionnaire}
            callback={uploadAnswer}
            editQuestion={editQuestion}
            header={(props) => (
              <Modal.Header p={0}>
                <HeaderEditAnswer
                  onBackClick={props.onBackClick}
                  showBackButton={props.showBackButton}
                  onCloseClick={onCloseClick}
                />
              </Modal.Header>
            )}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
}
